import { PropsWithChildren, ReactNode } from 'react';

import styles from './StlSidebarForm.module.css';

export default function StlSidebarFormWrapper({
  children,
  btns,
}: { btns?: ReactNode } & PropsWithChildren) {
  return (
    <div className={styles.task_bar_group_settings}>
      <div className={styles.input_form}>{children}</div>
      {btns}
    </div>
  );
}
